import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { useTheme } from "../context/ThemeContext";
import { Modal } from "antd";
import { toast } from "react-toastify";
import {
  getUserProfile,
  // getColorList,
  updateUserProfile,
  changeUserPassword,
  changeUserEmail,
  confirmUserEmailOtp,
} from "../services";
import { useNavigate } from "react-router-dom";

function Profile() {
  const { theme, colors } = useTheme();
  const navigate = useNavigate();

  const [userId, setUserId] = useState(null);
  // const [colorPalettes, setColorPalettes] = useState({});
  // const [selectedPalette, setSelectedPalette] = useState("");
  const [editUserType, setEditUserType] = useState("");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    userType: "",
    graphType: "",
  });

  const [showEditProfile, setShowEditProfile] = useState(false);
  const [showEditPassword, setShowEditPassword] = useState(false);
  const [showEditEmail, setShowEditEmail] = useState(false);
  const [showOtp, setShowOtp] = useState(false);

  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [newEmail, setNewEmail] = useState("");
  const [otp, setOtp] = useState("");

  // ================= FETCH PROFILE =================

 useEffect(() => {
  const user = JSON.parse(localStorage.getItem("MCData"));

  const id = user?.userid;
  setUserId(id);

  if (!id) return;

  getUserProfile(id).then((res) => {
    const data = res.data;

    setFormData({
      firstName: data.first_name,
      lastName: data.last_name,
      email: data.email,
      userType: data.user_type,
      graphType: user?.graphType || data.graph_type || "bar",
    });
      setEditUserType(data.user_type_code);    
  });
      // setSelectedPalette(data.color);

    // getColorList().then((res) => {
    //   setColorPalettes({
    //     p1: res.data[0]?.color_list,
    //     p2: res.data[1]?.color_list,
    //     p3: res.data[2]?.color_list,
    //   });
    // });
  }, []);

  // ================= UPDATE PROFILE =================

const handleUpdateProfile = () => {
  updateUserProfile({
    first_name: formData.firstName,
    last_name: formData.lastName,
    user_id: userId,
    user_type: editUserType,
     graph: formData.graphType,
  })
    .then((res) => {
      const user = JSON.parse(localStorage.getItem("MCData"));

      const updatedUser = {
        ...user,
        graphType: formData.graphType,
      };

      localStorage.setItem("MCData", JSON.stringify(updatedUser));

      // ✅ update UI immediately (NO reload)
      setFormData((prev) => ({
        ...prev,
        graphType: formData.graphType,
      }));

      toast.success(res.message);
      setShowEditProfile(false);
    })
    .catch((err) => toast.error(err.response?.data?.msg || "Error"));
};

  // ================= PASSWORD =================

  const handleUpdatePassword = () => {
    if (
      !passwordData.oldPassword ||
      !passwordData.newPassword ||
      !passwordData.confirmPassword
    ) {
      toast.error("All fields are required");
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast.error("New password and confirm password do not match");
      return;
    }

    changeUserPassword({
      first_name: formData.firstName,
      last_name: formData.lastName,
      username: formData.email,
      old_password: passwordData.oldPassword,
      new_password: passwordData.newPassword,
      confirm_password: passwordData.confirmPassword,
    })
      .then((res) => {
        toast.success(res.message);
        setShowEditPassword(false);

        // Reset fields after success
        setPasswordData({
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      })
      .catch((err) => toast.error(err.response?.data?.msg || "Error"));
  };

  // ================= EMAIL =================

  const handleEmailSubmit = () => {
    changeUserEmail(formData.email, newEmail)
      .then((res) => {
        toast.success(res.msg);

        // If already exists → stay in same modal
        if (res.msg?.toLowerCase().includes("already exists")) {
          setShowOtp(false);
        } else {
          setShowEditEmail(false);
          setShowOtp(true);
        }
      })
      .catch((err) => toast.error(err.response?.data?.msg || "Error"));
  };

  const handleOtpConfirm = () => {
    confirmUserEmailOtp({
      old_email: formData.email,
      otp,
    })
      .then(() => {
        toast.success("Email Changed Successfully");
        setShowOtp(false);
        navigate(0);
      })
      .catch((err) => toast.error(err.response?.data?.msg || "Error"));
  };

  return (
    <main className="flex-1 p-6" style={{ backgroundColor: colors.background }}>
      {/* HEADER */}
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={() => navigate(-1)}
          className="p-3 rounded-lg transition-all hover:scale-105"
          style={{
            backgroundColor: theme === "white" ? "#f0f0f0" : colors.glassEffect,
            color: colors.text,
          }}
        >
          <ArrowLeft />
        </button>

        <h1
          className="text-2xl md:text-3xl font-bold"
          style={{ color: colors.text }}
        >
          Profile Settings
        </h1>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div
          className="rounded-xl p-8 border"
          style={{
            backgroundColor: theme === "white" ? "#ffffff" : colors.glassEffect,
            borderColor: colors.border,
          }}
        >
          {/* PROFILE SUMMARY */}
          <div
            className="flex items-center gap-6 mb-8 pb-6 border-b"
            style={{ borderColor: colors.border }}
          >
            <div
              className="w-20 h-20 rounded-full flex items-center justify-center text-2xl font-bold"
              style={{
                backgroundColor: colors.primary,
                color: "#fff",
              }}
            >
              {formData.firstName?.charAt(0)}
            </div>

            <div>
              <h3
                className="text-xl font-bold mb-1"
                style={{ color: colors.text }}
              >
                {formData.firstName} {formData.lastName}
              </h3>
              <p style={{ color: colors.textSecondary }}>{formData.email}</p>
            </div>
          </div>

          <div className="space-y-6">
            {/* FIRST NAME */}
            <div>
              <label
                className="block text-sm font-medium mb-2"
                style={{ color: colors.textSecondary }}
              >
                First Name
              </label>
              <input
                type="text"
                readOnly
                value={formData.firstName}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    firstName: e.target.value,
                  })
                }
                className="w-full px-4 py-3 rounded-lg border"
                style={{
                  backgroundColor:
                    theme === "white" ? "#fafafa" : colors.background,
                  borderColor: colors.border,
                  color: colors.text,
                }}
              />
            </div>

            {/* LAST NAME */}
            <div>
              <label
                className="block text-sm font-medium mb-2"
                style={{ color: colors.textSecondary }}
              >
                Last Name
              </label>
              <input
                type="text"
                readOnly
                value={formData.lastName}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    lastName: e.target.value,
                  })
                }
                className="w-full px-4 py-3 rounded-lg border"
                style={{
                  backgroundColor:
                    theme === "white" ? "#fafafa" : colors.background,
                  borderColor: colors.border,
                  color: colors.text,
                }}
              />
            </div>

            {/* EMAIL */}
            <div>
              <label
                className="block text-sm font-medium mb-2"
                style={{ color: colors.textSecondary }}
              >
                Email
              </label>
              <input
                type="email"
                value={formData.email}
                readOnly
                className="w-full px-4 py-3 rounded-lg border cursor-not-allowed"
                style={{
                  backgroundColor:
                    theme === "white" ? "#f5f5f5" : `${colors.background}80`,
                  borderColor: colors.border,
                  color: colors.textSecondary,
                }}
              />
            </div>

            {/* USER TYPE */}
            <div>
              <label
                className="block text-sm font-medium mb-2"
                style={{ color: colors.textSecondary }}
              >
                User Type
              </label>
              <input
                type="text"
                value={formData.userType}
                readOnly
                className="w-full px-4 py-3 rounded-lg border cursor-not-allowed"
                style={{
                  backgroundColor:
                    theme === "white" ? "#f5f5f5" : `${colors.background}80`,
                  borderColor: colors.border,
                  color: colors.textSecondary,
                }}
              />
            </div>

           {/* GRAPH TYPE */}
<div>
  <label
    className="block text-sm font-medium mb-2"
    style={{ color: colors.textSecondary }}
  >
    Graph Type
  </label>

  <input
    type="text"
    value={
      formData.graphType === "bar"
        ? "Bar Chart"
        : formData.graphType === "line"
        ? "Line Chart"
        : ""
    }
    readOnly
    className="w-full px-4 py-3 rounded-lg border cursor-not-allowed"
    style={{
      backgroundColor:
        theme === "white" ? "#f5f5f5" : `${colors.background}80`,
      borderColor: colors.border,
      color: colors.textSecondary,
    }}
  />
</div>

            {/* COLOUR PALETTE */}
            {/* <div>
              <label
                className="block text-sm font-medium mb-3"
                style={{ color: colors.textSecondary }}
              >
                Colour Palette
              </label>

              {selectedPalette && (
                <div>
                 
                  <p
                    className="text-sm mb-3 font-semibold"
                    style={{ color: colors.primary }}
                  >
                    {selectedPalette === "Color Palette 1"
                      ? "Sky D3"
                      : selectedPalette === "Color Palette 2"
                        ? "Positive Colours"
                        : selectedPalette === "Color Palette 3"
                          ? "Google Colours"
                          : selectedPalette}
                  </p>

                  
                  <div className="flex gap-2 flex-wrap">
                    {(selectedPalette === "Color Palette 1"
                      ? colorPalettes.p1
                      : selectedPalette === "Color Palette 2"
                        ? colorPalettes.p2
                        : selectedPalette === "Color Palette 3"
                          ? colorPalettes.p3
                          : []
                    )
                      ?.slice(0, 8)
                      ?.map((c, i) => (
                        <div
                          key={i}
                          className="w-8 h-8 rounded-md"
                          style={{ backgroundColor: c }}
                        />
                      ))}
                  </div>
                </div>
              )}
            </div> */}

            {/* ACTION BUTTONS */}
            <div className="flex gap-4 pt-6">
              <button
                onClick={() => setShowEditProfile(true)}
                className="px-6 py-3 rounded-lg text-white transition-all hover:scale-105"
                style={{
                  backgroundImage: colors.gradient,
                }}
              >
                Edit Profile Details
              </button>

              <button
                onClick={() => setShowEditEmail(true)}
                className="px-6 py-3 rounded-lg text-white transition-all hover:scale-105"
                style={{
                  backgroundColor: colors.primary,
                }}
              >
                Edit Email
              </button>

              <button
                onClick={() => setShowEditPassword(true)}
                className="px-6 py-3 rounded-lg text-white transition-all hover:scale-105"
                style={{
                  backgroundColor: colors.secondary || colors.primary,
                }}
              >
                Edit Password
              </button>
            </div>
          </div>
        </div>
      </motion.div>

      {/* ================= MODALS ================= */}
      {showEditProfile && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm"
            onClick={() => setShowEditProfile(false)}
          />

          <motion.div
            className="rounded-xl border w-full max-w-lg z-10 overflow-hidden"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            style={{
              backgroundColor: colors.background,
              borderColor: colors.border,
            }}
          >
            {/* Header */}
            <div
              className="flex items-center justify-between p-6 border-b"
              style={{ borderColor: `${colors.primary}20` }}
            >
              <h2 className="text-2xl font-bold" style={{ color: colors.text }}>
                Edit Profile Details
              </h2>
              <button
                onClick={() => setShowEditProfile(false)}
                className="text-[#BDB9B5] hover:text-white"
              >
                ✕
              </button>
            </div>

            {/* Body */}
            <div className="p-6 space-y-5">
              {/* First Name */}
              <div>
                <label
                  className="block text-sm font-semibold mb-2"
                  style={{ color: colors.primary }}
                >
                  First Name
                </label>
                <input
                  type="text"
                  value={formData.firstName}
                  onChange={(e) =>
                    setFormData({ ...formData, firstName: e.target.value })
                  }
                  className="w-full px-4 py-2.5 rounded-lg"
                  style={{
                    backgroundColor: colors.background,
                    border: `1px solid ${colors.border}`,
                    color: colors.text,
                  }}
                />
              </div>

              {/* Last Name */}
              <div>
                <label
                  className="block text-sm font-semibold mb-2"
                  style={{ color: colors.primary }}
                >
                  Last Name
                </label>
                <input
                  type="text"
                  value={formData.lastName}
                  onChange={(e) =>
                    setFormData({ ...formData, lastName: e.target.value })
                  }
                  className="w-full px-4 py-2.5 rounded-lg"
                  style={{
                    backgroundColor: colors.background,
                    border: `1px solid ${colors.border}`,
                    color: colors.text,
                  }}
                />
              </div>

              {/* GRAPH TYPE */}
<div>
  <label
    className="block text-sm font-semibold mb-2"
    style={{ color: colors.primary }}
  >
    Graph Type
  </label>

  <select
    value={formData.graphType}
    onChange={(e) =>
      setFormData({ ...formData, graphType: e.target.value })
    }
    className="w-full px-4 py-2.5 rounded-lg"
    style={{
      backgroundColor: colors.background,
      border: `1px solid ${colors.border}`,
      color: colors.text,
    }}
  >
    <option value="bar">Bar Chart</option>
    <option value="line">Line Chart</option>
  </select>
</div>

              {/* User Type (Only if Logged User is Super Admin) */}
              {editUserType === "SA" && (
                <div>
                  <label
                    className="block text-sm font-semibold mb-2"
                    style={{ color: colors.primary }}
                  >
                    User Type
                  </label>
                  <select
                    value={editUserType}
                    onChange={(e) => setEditUserType(e.target.value)}
                    className="w-full px-4 py-2.5 rounded-lg"
                    style={{
                      backgroundColor: colors.background,
                      border: `1px solid ${colors.border}`,
                      color: colors.text,
                    }}
                  >
                    <option value="SA">Super Admin</option>
                    <option value="A">Admin</option>
                    <option value="U">User</option>
                  </select>
                </div>
              )}

              {/* Change Palette */}
              {/* <div>
                <label className="block text-sm font-semibold text-[#00b8f1] mb-3">
                  Change Palette
                </label>

                {[
                  {
                    key: "Color Palette 1",
                    label: "Sky D3",
                    data: colorPalettes.p1,
                  },
                  {
                    key: "Color Palette 2",
                    label: "Positive Colours",
                    data: colorPalettes.p2,
                  },
                  {
                    key: "Color Palette 3",
                    label: "Google Colours",
                    data: colorPalettes.p3,
                  },
                ].map((palette) => (
                  <div
                    key={palette.key}
                    className="flex items-center gap-3 mb-4"
                  >
                    <input
                      type="radio"
                      checked={selectedPalette === palette.key}
                      onChange={() => setSelectedPalette(palette.key)}
                    />
                    <span className="text-white">{palette.label}</span>

                    <div className="flex gap-1">
                      {palette.data?.slice(0, 8).map((c, i) => (
                        <div
                          key={i}
                          className="w-4 h-4 rounded"
                          style={{ backgroundColor: c }}
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </div> */}
            </div>

            {/* Footer */}
            <div
              className="flex items-center justify-end gap-3 p-6 border-t"
              style={{ borderColor: `${colors.primary}20` }}
            >
              <button
                onClick={() => setShowEditProfile(false)}
                className="px-6 py-2.5"
                style={{ color: colors.textSecondary }}
              >
                Cancel
              </button>

              <button
                onClick={handleUpdateProfile}
                className="px-6 py-2.5 text-white rounded-lg"
                style={{ backgroundColor: colors.primary }}
              >
                Update
              </button>
            </div>
          </motion.div>
        </div>
      )}

      {showEditPassword && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm"
            onClick={() => setShowEditPassword(false)}
          />

          <motion.div
            className=" rounded-xl border w-full max-w-lg z-10 overflow-hidden"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            style={{
              backgroundColor: colors.background,
              borderColor: colors.border,
            }}
          >
            {/* Header */}
            <div
              className="flex items-center justify-between p-6 border-b"
              style={{ borderColor: `${colors.primary}20` }}
            >
              <h2 className="text-2xl font-bold" style={{ color: colors.text }}>
                Change Password
              </h2>
              <button
                onClick={() => setShowEditPassword(false)}
                style={{
                  color: colors.textSecondary,
                }}
              >
                ✕
              </button>
            </div>

            {/* Body */}
            <div className="p-6 space-y-5">
              {/* Old Password */}
              <div>
                <label
                  className="block text-sm font-semibold mb-2"
                  style={{ color: colors.primary }}
                >
                  Old Password
                </label>
                <input
                  type="password"
                  value={passwordData.oldPassword}
                  onChange={(e) =>
                    setPasswordData({
                      ...passwordData,
                      oldPassword: e.target.value,
                    })
                  }
                  placeholder="Enter Old Password"
                  className="w-full px-4 py-2.5 rounded-lg"
                  style={{
                    backgroundColor: colors.background,
                    border: `1px solid ${colors.border}`,
                    color: colors.text,
                  }}
                />
              </div>

              {/* New Password */}
              <div>
                <label
                  className="block text-sm font-semibold mb-2"
                  style={{ color: colors.primary }}
                >
                  New Password
                </label>
                <input
                  type="password"
                  value={passwordData.newPassword}
                  onChange={(e) =>
                    setPasswordData({
                      ...passwordData,
                      newPassword: e.target.value,
                    })
                  }
                  placeholder="Enter New Password"
                  className="w-full px-4 py-2.5 rounded-lg"
                  style={{
                    backgroundColor: colors.background,
                    border: `1px solid ${colors.border}`,
                    color: colors.text,
                  }}
                />
              </div>

              {/* Confirm Password */}
              <div>
                <label
                  className="block text-sm font-semibold mb-2"
                  style={{ color: colors.primary }}
                >
                  Confirm Password
                </label>
                <input
                  type="password"
                  value={passwordData.confirmPassword}
                  onChange={(e) =>
                    setPasswordData({
                      ...passwordData,
                      confirmPassword: e.target.value,
                    })
                  }
                  placeholder="Confirm New Password"
                  className="w-full px-4 py-2.5 rounded-lg"
                  style={{
                    backgroundColor: colors.background,
                    border: `1px solid ${colors.border}`,
                    color: colors.text,
                  }}
                />
              </div>
            </div>

            {/* Footer */}
            <div
              className="flex items-center justify-end gap-3 p-6 border-t"
              style={{ borderColor: `${colors.primary}20` }}
            >
              <button
                onClick={() => setShowEditPassword(false)}
                className="px-6 py-2.5"
                style={{ color: colors.textSecondary }}
              >
                Cancel
              </button>

              <button
                onClick={handleUpdatePassword}
                className="px-6 py-2.5 text-white rounded-lg"
                style={{ backgroundColor: colors.primary }}
              >
                Update
              </button>
            </div>
          </motion.div>
        </div>
      )}

      {showEditEmail && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm"
            onClick={() => setShowEditEmail(false)}
          />

          <motion.div
            className=" rounded-xl border w-full max-w-lg z-10 overflow-hidden"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            style={{
              backgroundColor: colors.background,
              borderColor: colors.border,
            }}
          >
            {/* Header */}
            <div
              className="flex items-center justify-between p-6 border-b"
              style={{ borderColor: `${colors.primary}20` }}
            >
              <h2 className="text-2xl font-bold" style={{ color: colors.text }}>
                Change Email
              </h2>
              <button
                onClick={() => setShowEditEmail(false)}
                className="text-[#BDB9B5] hover:text-white"
              >
                ✕
              </button>
            </div>

            {/* Body */}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleEmailSubmit();
              }}
              className="p-6 space-y-5"
            >
              {/* Current Email */}
              <div>
                <label
                  className="block text-sm font-semibold mb-2"
                  style={{ color: colors.primary }}
                >
                  Current Email
                </label>
                <input
                  type="email"
                  value={formData.email}
                  disabled
                  className="w-full px-4 py-2.5  rounded-lg cursor-not-allowed"
                  style={{
                    backgroundColor: colors.background,
                    border: `1px solid ${colors.border}`,
                    color: colors.textSecondary,
                  }}
                />
              </div>

              {/* New Email */}
              <div>
                <label
                  className="block text-sm font-semibold mb-2"
                  style={{ color: colors.primary }}
                >
                  New Email
                </label>
                <input
                  type="email"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  placeholder="Enter New Email"
                  required
                  className="w-full px-4 py-2.5 rounded-lg outline-none"
                  style={{
                    backgroundColor: colors.background,
                    border: `1px solid ${colors.border}`,
                    color: colors.text,
                  }}
                />
              </div>

              {/* Footer */}
              <div
                className="flex items-center justify-end gap-3 p-6 border-t"
                style={{ borderColor: `${colors.primary}20` }}
              >
                <button
                  type="button"
                  onClick={() => setShowEditEmail(false)}
                  className="px-6 py-2.5"
                  style={{ color: colors.textSecondary }}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="px-6 py-2.5 text-white rounded-lg"
                  style={{ backgroundColor: colors.primary }}
                >
                  Submit
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      )}
      {showOtp && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm"
            onClick={() => setShowOtp(false)}
          />

          <motion.div
            className="rounded-xl border w-full max-w-md z-10 overflow-hidden"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            style={{
              backgroundColor: colors.background,
              borderColor: colors.border,
            }}
          >
            {/* Header */}
            <div
              className="flex items-center justify-between p-6 border-b"
              style={{ borderColor: `${colors.primary}20` }}
            >
              <h2 className="text-2xl font-bold text-white">Verify Email</h2>
              <button
                onClick={() => setShowOtp(false)}
                className="text-[#BDB9B5] hover:text-white"
              >
                ✕
              </button>
            </div>

            {/* Body */}
            <div className="p-6 space-y-6">
              <p className="text-[#BDB9B5] text-sm">
                Please enter the OTP sent to your email address.
              </p>

              {/* OTP Input */}
              <div>
                <label
                  className="block text-sm font-semibold mb-2"
                  style={{ color: colors.primary }}
                >
                  Enter OTP
                </label>

                <input
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter 6-digit OTP"
                  maxLength={6}
                  className="w-full px-4 py-3 bg-[#0a1628] border border-[#2a2520] rounded-lg text-white text-center tracking-widest text-lg focus:border-[#00b8f1] outline-none"
                />
              </div>
            </div>

            {/* Footer */}
            <div
              className="flex items-center justify-end gap-3 p-6 border-t"
              style={{ borderColor: `${colors.primary}20` }}
            >
              <button
                onClick={() => setShowOtp(false)}
                className="px-6 py-2.5"
                style={{ color: colors.textSecondary }}
              >
                Cancel
              </button>

              <button
                onClick={handleOtpConfirm}
                className="px-6 py-2.5 text-white rounded-lg"
                style={{ backgroundColor: colors.primary }}
              >
                Verify
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </main>
  );
}

export default Profile;
